<h1 mat-dialog-title class="p-2 text-center">{{Title}} </h1>
<div class="p-3">
    <div class="col">
        <div class="">
            <div class="row">
                <mat-form-field class="col">
                    <mat-label>SampleCode</mat-label>
                    <input matInput placeholder="SampleCode" [(ngModel)]="SampleCode" >
                </mat-form-field>
            </div>

            <div class="row">
                <button class="col mx-3 my-2" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="accent" (throttledClick)="onCancel()" >
                    Annuler<mat-icon>undo</mat-icon>
                </button>

                <button class="col mx-3 my-2" appPreventDoubleClick [throttleTime]="200" mat-raised-button color="primary" (throttledClick)="onConfirm()" [disabled]="!CanAddNewMeasure()">
                    Enregistrer<mat-icon>save</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>